import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCashRegister,
  faChartBar,
  faCartShopping,
  faUser,
  faPaperclip,
  faGear,
  faDollar,
  faBox,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import { NavigationLink } from "navigation-react";
import { RoleContext } from "./App";

const DashboardContenLeftMenus = () => {
  // ✅ Use roles from context and destructure
  const { roles } = useContext(RoleContext);
  console.log("roles:", roles);

  return (
    <aside className="sidebar">
      <ul className="menu">
        <li>
          <NavigationLink stateKey="dashboardcontent">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faChartBar} className="menu-icon" />
              <span className="menu-text">Dashboard</span>
            </div>
          </NavigationLink>
        </li>

        <li>
          <NavigationLink stateKey="viewsalesregister">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faDollar} className="menu-icon" />
              <span className="menu-text">Sales</span>
            </div>
          </NavigationLink>
        </li>

        <li>
          <NavigationLink stateKey="onlineorders">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faCartShopping} className="menu-icon" />
              <span className="menu-text">Orders</span>
            </div>
          </NavigationLink>
        </li>

        <li>
          <NavigationLink stateKey="productregister">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faBox} className="menu-icon" />
              <span className="menu-text">Products</span>
            </div>
          </NavigationLink>
        </li>

        <li>
          <NavigationLink stateKey="stockinventory">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faCashRegister} className="menu-icon" />
              <span className="menu-text">Inventory</span>
            </div>
          </NavigationLink>
        </li>

        <li>
          <NavigationLink stateKey="customerregister">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faUserAlt} className="menu-icon" />
              <span className="menu-text">Customers</span>
            </div>
          </NavigationLink>
        </li>

        <li>
          <NavigationLink stateKey="">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faGear} className="menu-icon" />
              <span className="menu-text">Settings</span>
            </div>
          </NavigationLink>
        </li>

        {/* <li>
          <NavigationLink stateKey="stockinventory">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faPaperclip} className="menu-icon" />
              <span className="menu-text">Reports</span>
            </div>
          </NavigationLink>
        </li>

        <li>
          <NavigationLink stateKey="stockinventory">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faUser} className="menu-icon" />
              <span className="menu-text">Users</span>
            </div>
          </NavigationLink>
        </li>

        <li>
          <NavigationLink stateKey="stockinventory">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faGear} className="menu-icon" />
              <span className="menu-text">Settings</span>
            </div>
          </NavigationLink>
        </li> */}

        {/* <li>
          <NavigationLink stateKey="staffsignregister">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faUsers} className="menu-icon" />
              <span className="menu-text">Staff</span>
            </div>
          </NavigationLink>
        </li> */}

        {/* <li>
          <NavigationLink stateKey="deliveriesregister">
            <div className="menu-circle">
              <FontAwesomeIcon icon={faCube} className="menu-icon" />
              <span className="menu-text">Deliveries</span>
            </div>
          </NavigationLink>
        </li> */}

        {/* {(roles.includes("administrator") ||
          roles.includes("consularadmin")) && (
          <li>
            <NavigationLink stateKey="staffregister">
              <div className="menu-circle">
                <FontAwesomeIcon icon={faPersonRifle} className="menu-icon" />
                <span className="menu-text">Staff Register</span>
              </div>
            </NavigationLink>
          </li>
        )} */}

        {/* {(roles.includes("administrator") ||
          roles.includes("consularadmin")) && (
          <li>
            <NavigationLink stateKey="">
              <div className="menu-circle">
                <FontAwesomeIcon icon={faPager} className="menu-icon" />
                <span className="menu-text">Logs</span>
              </div>
            </NavigationLink>
          </li>
        )} */}
      </ul>
    </aside>
  );
};

export default DashboardContenLeftMenus;
